import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export const CompareSlider = ({ before, after, alt, testId }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100)));
  };
  const onDown = (e) => { dragging.current = true; ref.current.setPointerCapture(e.pointerId); update(e.clientX); };
  const onMove = (e) => { if (dragging.current) update(e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      onPointerDown={onDown}
      onPointerMove={onMove}
      onPointerUp={onUp}
      onPointerCancel={onUp}
      className="relative aspect-[4/3] w-full select-none overflow-hidden cursor-ew-resize touch-pan-y bg-sand"
      data-testid={testId}
    >
      <img src={after} alt={`${alt} — after`} className="absolute inset-0 h-full w-full object-cover pointer-events-none" draggable={false} />
      <div className="absolute inset-0 pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={`${alt} — before`} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
      </div>
      <span className="absolute top-4 left-4 bg-ink/80 text-bone font-mono text-[10px] uppercase tracking-[0.16em] px-2.5 py-1.5 pointer-events-none">Before</span>
      <span className="absolute top-4 right-4 bg-teal text-bone font-mono text-[10px] uppercase tracking-[0.16em] px-2.5 py-1.5 pointer-events-none">After</span>
      <div className="absolute inset-y-0 w-px bg-bone pointer-events-none" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-12 w-12 bg-bone text-ink flex items-center justify-center shadow-lg">
          <ChevronsLeftRight className="h-5 w-5" />
        </span>
      </div>
    </div>
  );
};
